export default __webpack_public_path__ + "static/media/FiraSansExtraCondensed-Medium.0c86e694.ttf";